import React, { Component } from "react";
import TextLoop from "react-text-loop";
import "./home-page.scss";
import ProgressBar from "../../components/progress-bar/progress-bar";

class HomePage extends Component {
  state = {
    showJoiningAnimation: true
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ showJoiningAnimation: false });  
    }, 2000);
  }

  _onJoin = () => {
    this.setState({ showJoiningAnimation: true });
    setTimeout(() => {
      this.props.history.push("/board");
    }, 2000);
  }
  render() {
    const { showJoiningAnimation } = this.state;
    
    return (
      <>
        <div className={`homepageWrapper ${showJoiningAnimation && "loaderMode"}`}>
          <div className="brandWrapper">
            <div className="brand">
              <img src={require("../../assets/images/C-01.png")} alt="" />
              <div className="text">
                {
                  showJoiningAnimation? (
                    <ProgressBar interval={2000} />
                  ): (
                    <>
                    <p className="title">CLIPSYNC</p>
                    <p className="subTitle">Multi Device Clipboard</p>

                    </>
                  )
                }
              </div>
            </div>
          </div>
          <div className="actionWrapper">
            <div className="animationWrapper">
              <h5>
                <div className="level1">
                  Share{" "}
                  <TextLoop
                    interval={2200}
                    springConfig={{ stiffness: 2540, damping: 60 }}
                  >
                    <span className="animatedText">Files</span>
                    <span className="animatedText">Text</span>
                    <span className="animatedText">Code Snippents</span>
                  </TextLoop>{" "}
                </div>
                <br />
                Across devices!
              </h5>
              <img src={require("../../assets/images/white.gif")} alt="" />
            </div>
            <div className="formWrapper">
              <div className="joinBox">
                <input type="text" placeholder="Enter board name" autoFocus />
                <button
                  className="hvr-swipe-to-right"
                  onClick={(e) => this._onJoin()}
                >
                  Connect &nbsp; <i className="fas fa-sign-in-alt"></i>
                </button>
              </div>
              <div className="orLabel">OR</div>
              <div className="createRoomWrapper">
                <h3>Start sharing by creating your own board</h3>
                <button onClick={(e) => this._onJoin()}>
                  Create a new clipboard &nbsp;{" "}
                  <i className="fas fa-plus-circle"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default HomePage;
